import { ModelCommon } from '../../model/ModelCommon'

import { SYSTEM } from '../../constants'
import config from '@iotv/config'
import { MapLike } from '@iotv/iotv-v3-types'
const debug = !process.env.AWS_SESSION_TOKEN && false

export class System<T extends MapLike<any>> extends ModelCommon {
  constructor(ob: T) {
    super(SYSTEM.type, { ...ob, ...SYSTEM })
  }
}
